import React, { useState, useEffect } from "react";
import Select from "react-select";
import clienteAxios from "../../config/Axios";

const HelpForSeller = ({ detectarCambiosHelpForSeller, onSellerChange }) => {
  const [helpValue, setHelpValue] = useState(null);
  const [sellers, setSellers] = useState([]);
  const [loadingSellers, setLoadingSellers] = useState(false);

  const helpOptions = [
    { label: "Sí", value: "si" },
    { label: "No", value: "no" },
  ];

  // Fetch sellers when user selects "Si"
  useEffect(() => {
    if (helpValue === "si") {
      setLoadingSellers(true);
      clienteAxios
        .get("/distribucion/sellers")
        .then((res) => {
          const sellerOptions = res.data.map((seller) => ({
            label: seller.name,
            value: seller.name,
            id: seller.id,
          }));
          setSellers(sellerOptions);
        })
        .catch((err) => {
          console.error("Error fetching sellers:", err);
          setSellers([]);
        })
        .finally(() => setLoadingSellers(false));
    } else {
      setSellers([]);
      if (onSellerChange) onSellerChange(null);
    }
  }, [helpValue, onSellerChange]);

  const handleHelpChange = (option) => {
    setHelpValue(option?.value || null);
    detectarCambiosHelpForSeller(option);

    // If "No", clear seller
    if (option?.value === "no" && onSellerChange) {
      onSellerChange(null);
    }
  };

  const handleSellerChange = (option) => {
    if (onSellerChange) {
      onSellerChange(option?.value || null);
    }
  };

  const selectStyles = {
    control: (base, state) => ({
      ...base,
      borderColor: state.isFocused ? "#801F56" : base.borderColor,
      boxShadow: state.isFocused ? "0 0 0 1px #801F56" : base.boxShadow,
      "&:hover": { borderColor: "#E46EA7" },
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected
        ? "#801F56"
        : state.isFocused
          ? "#FFF0F5"
          : base.backgroundColor,
      color: state.isSelected ? "#fff" : "#2D1B30",
      "&:active": { backgroundColor: "#E46EA7" },
    }),
  };

  return (
    <>
      <Select
        onChange={handleHelpChange}
        className="basic-single"
        classNamePrefix="select"
        name="help_for_seller"
        placeholder="Selecciona una opción"
        options={helpOptions}
        styles={selectStyles}
      />

      {helpValue === "si" && (
        <div style={{ marginTop: 12 }}>
          <p style={{ fontSize: 14, fontWeight: 600, marginBottom: 6, color: "#2D1B30" }}>
            ¿Quién te atendió?
          </p>
          <Select
            onChange={handleSellerChange}
            className="basic-single"
            classNamePrefix="select"
            name="seller_name"
            placeholder={loadingSellers ? "Cargando vendedoras..." : "Selecciona la vendedora"}
            options={sellers}
            isLoading={loadingSellers}
            isDisabled={loadingSellers}
            noOptionsMessage={() => "No se encontraron vendedoras"}
            styles={selectStyles}
          />
        </div>
      )}
    </>
  );
};

export default HelpForSeller;
